'use strict';

const data = require('../../data.cjs');
const index = require('../node/index.cjs');

const lexerConfig = {
    generic: true,
    ...data,
    node: index
};

module.exports = lexerConfig;
